import { graphql } from '@/gql';
import type { UpdateCallerSubscriptionWithoutChargeMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateCallerSubscriptionWithoutCharge = async ({
  callerId,
  planName,
  periodEndAt,
  notes,
  refundType,
  refundAmount,
  refundAsCredits,
}: UpdateCallerSubscriptionWithoutChargeMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      planName,
      periodEndAt,
      notes,
      refundType,
      refundAmount,
      refundAsCredits,
    },
    mutation: graphql(`
      mutation UpdateCallerSubscriptionWithoutCharge(
        $callerId: String!
        $planName: String!
        $periodEndAt: String!
        $refundType: String!
        $refundAmount: Float
        $notes: String!
        $refundAsCredits: Boolean
      ) {
        updateCallerSubscriptionWithoutCharge(
          callerId: $callerId
          planName: $planName
          periodEndAt: $periodEndAt
          refundType: $refundType
          refundAmount: $refundAmount
          notes: $notes
          refundAsCredits: $refundAsCredits
        ) {
          id
          callerId
          planName
          nextPlanName
          periodStartAt
          periodEndAt
          expectedPeriodEndAt
          isTrial
          transactionId
          timePlanSuspendPeriodStartDate
          timePlanSuspendPeriodEndDate
        }
      }
    `),
  });

  return response.data?.updateCallerSubscriptionWithoutCharge;
};
